import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import success from "../../../src/waitlistDocVault/assets/images/success.png";
import { toast, ToastContainer } from "react-toastify";
import { getThirdPartyData, getUserNameFromPan, updateThirdPartyData, processUserAfterPan } from "../../waitlist/services/waitlist-service";

import { get } from "lodash";
import { ButtonWithLoader, OroDobPicker } from "../../core";
// import { Mixpanel } from "../../waitlist/components/MixPanel";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import { utils } from "../../core/helpers/utils";

export default function KycPANContentNew(props) {
  const [isPan, setIsPan] = useState(false);
  const [pan, setPan] = useState("");
  const [show, setShow] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [userName, setUserName] = useState("");
  const [verifyLoader, setVerifyLoader] = useState(false);
  const [dob, setDob] = useState(null);
  const [income, setIncome] = useState(null);
  const [gender, setGender] = useState(null);

  function toggle() {
    setShow(!show);
  }

  function closeHeader() {
    setShow(!show);
    props.moveNextTab();
  }

  const thirdPartyData = (payload, headers) => {
    return updateThirdPartyData(payload, headers)
      .then((resp) => {
        return resp;
      });
  };

  const verifyPAN = (inputPan) => {
    setVerifyLoader(true);
    if (!inputPan) {
      setVerifyLoader(false);
      return toast.error("PAN required");
    }

    return getUserNameFromPan(inputPan, {"X-product": `orobonds:default`})
      .then((response) => {
        setVerifyLoader(false);
        if (!response || !response.success) {
          setUserName("");
          if (response.message === "PAN not unique") {
            return toast.error(
              "Sorry, this PAN is already registered, please try another PAN or contact connect@biddeasy.com."
            );
          }
          return toast.error(
            response.message || "something went wrong: getUserNameFromPan"
          );
        }
        if (response && response.data) {
          let payload = utils.encryptedPayload({
            pan: response.data.pan,
            productName: 'oroBonds',
            name: response.data.full_name,
            gender,
            income,
            dob: dob.dob || null
          });
          return thirdPartyData(payload, {"X-product": `orobonds:default`, 'x-encrypted-data': true}).then(
            tpd => {
              if (!tpd || !tpd.success) {
                toast.error(tpd.msg || "Error: Unable to update user data");
                return;
              }
              // processUserAfter();
              setUserName(get(response, "data.full_name", ""));
              /* Mixpanel.track("cl_next_pan_docvault",
                {
                  "Email id": props.email ? props.email : ""
                }
              ); */
              setAnalyticsEvent("Bonds_KYC_Pan_Success");
              setAnalyticsEvent("Bonds_KYC_Bank_Verfied");
              props.passBackPanValue(response.data.pan);
              setIsPan(true);
              props.setReupload(true);
              setTimeout(() => {
                setShow(true);
              }, 1500);              
            }
          )        
        }
      });
  };

  const setPanValue = (val) => {
    val = val.toUpperCase();
    setPan(val);
  };

  const getRecentPan = () => {
    let data;
    let tmpPan;

    getThirdPartyData({"X-product": `orobonds:default`, 'x-encrypted-data': true})
      .then((result) => {
        const response = utils.parsePayload(result);
        if (response && response.success && response.data) {
          data = response.data;
          tmpPan = data && data.pan ? data.pan : "";
          setPan(tmpPan.toUpperCase());
          props.passBackPanValue(tmpPan);
        }
      });
  };

  const processUserAfter = () => {
    processUserAfterPan({"X-product": `orobonds:default`})
      .then((response) => {
        if (response && response.success && response.data) {
          console.log('##success:', response)
        }
      });
  }

  useEffect(() => {
    let mobile = window.matchMedia("(max-width: 768px").matches;
    setIsMobile(mobile);
    getRecentPan();
  }, []);

  useEffect(() => {
    if (show) {
      props.updateDocStatus();
      setTimeout(() => {
        props.moveNextTab();
      }, 2000);
    }
  }, [show]);

  const updateDob = (date) => {
    setDob(date)
  }

  const selectIncome = (val) => {
    setIncome(val);
  }

  const selectGender = (val) => {
    setGender(val);
  }

  return (
    <>
      <div className="kyc-content-block">
        <Container className="form-container justify-content-center">
          <Row>
            <Col>
              <div className={!isMobile ? "pan-banner border" : "pan-banner-mob border"}>
                <div>
                  <Form onSubmit={(e) => e.preventDefault()} className="form-container">
                    <h4 style={{ color: "black" }}>
                      <strong className="text-capitalize">{"Verify your details"}</strong>
                    </h4>

                    <div className="">
                      <div className="mt-5 mb-2 justify-content-between">
                        <p className="d-flex font-size-tiny mb-2 text-muted">PAN*</p>
                        <Input
                          type="text"
                          name="PAN"
                          value={pan}
                          maxLength={10}
                          placeholder="PAN Number*"
                          onChange={(e) => setPanValue(e.target.value)}
                        />
                      </div>

                      {!userName ? (
                        ""
                      ) : (
                        <div>
                          <p
                            style={{ color: "#22c979" }}
                            className={"text-left mt-3"}
                          >
                            {userName}
                          </p>
                        </div>
                      )}
                    </div>
                    <OroDobPicker 
                      label="Date of birth*"
                      onDateUpdated={updateDob}
                      classname="text-left"
                    />
                    <select
                      className="select-dropdown font-weight-semi-bold"
                      onChange={(e) => selectIncome(e.target.value)}
                      defaultValue="0"
                    >
                      <option value="0" key="none" disabled>Annual Income*</option>
                      <option value="1">Less than 1 lakh</option>
                      <option value="2">1-5 lakh</option>
                      <option value="3">5-10 lakh</option>
                      <option value="4">10-25 lakh</option>
                      <option value="5">More than 25 lakh</option>
                    </select>
                    <select
                      className="select-dropdown font-weight-semi-bold"
                      onChange={(e) => selectGender(e.target.value)}
                      defaultValue="0"
                    >
                      <option value="0" key="none" disabled>Gender*</option>
                      <option value="F">Female</option>
                      <option value="M">Male</option>
                      <option value="O">Others</option>
                    </select>
                    <p className="text-muted">
                      Have questions while filling in the details? Connect with us on 
                      <b>
                        <a className="text-muted" href="https://wa.me/919324273606?text=Hello%2C%20I%20have%20a%20question%20while%20completing%20my%20KYC%20verification.%20Can%20you%20help%20me%20out%3F">
                          {' '}WhatsApp
                        </a>
                      </b>.
                    </p>
                    <FormGroup>
                      <br />
                      <ButtonWithLoader
                        color="#22c979"
                        className="mt-1"
                        onClick={() => verifyPAN(pan)}
                        disabled={
                          !pan || !dob || !income || !gender
                        }
                        text="Next"
                      />
                    </FormGroup>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {show && (
        <Modal centered isOpen={show} toggle={toggle}>
          <ModalHeader className="close-button p-0">
            <span onClick={closeHeader}>x</span>
          </ModalHeader>
          <ModalBody style={{marginTop: '-20px'}}>
            <div>
              <div className="pt-1">
                <img
                  style={{
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  src={success}
                  alt="success-icon"
                ></img>
              </div>

              <p className="text-center mt-4 font-size-20 font-weight-semi-bold">
                PAN has been validated successfully
              </p>
            </div>
          </ModalBody>
        </Modal>
      )}
      <ToastContainer />
    </>
  );
}
